export const getDynamicAdCoverStyles = () => ({
  container: {
    width: '1180px',
  },
  'container-xl': {
    width: '980px',
  },
  'container-l': {
    width: '640px',
  },
  'container-m': {
    width: '480px',
  },
  'container-s': {
    width: '360px',
  },
});
